import { CENSORED_LOANREQUEST_STATUSES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const CensoredLoanRequestsTableDefinitionZod = z.object({
    errors: z.array(z.string()),
    id: schemaId,
    status: z.nativeEnum(CENSORED_LOANREQUEST_STATUSES),
    totalFailed: z.number().nullable(),
    totalModified: z.number().nullable(),
    totalSuccessful: z.number().nullable(),
});

export type CensoredLoanRequestsTableSchema = z.infer<typeof CensoredLoanRequestsTableDefinitionZod>;
